import { Module, ActionContext } from 'vuex'
import { RootState, BlogPostFilters } from '../store'

export interface BlogState {
  blogPostsFilters: BlogPostFilters
}

type BlogActionContext = ActionContext<BlogState, RootState>

export default class BlogModule implements Module<BlogState, RootState> {
  state: BlogState

  actions: {
    filterBlogPosts: (context: BlogActionContext, by: BlogPostFilters) => void
  }

  mutations: {
    setFilters: (state: BlogState, filters: BlogPostFilters) => void
  }

  constructor () {
    this.state = {
      blogPostsFilters: {
        text: undefined,
        from: undefined,
        to: undefined
      }
    }

    this.mutations = {
      setFilters: (state, filters) => {
        state.blogPostsFilters = { ...state.blogPostsFilters, ...filters }
      }
    }

    this.actions = {
      filterBlogPosts: (context, by) => {
        context.commit('setFilters', by)
      }
    }
  }

}
